// extracted by mini-css-extract-plugin
module.exports = {"discountPriceWrapper":"styles-module__discountPriceWrapper___1j0Sh","originalPrice":"styles-module__originalPrice___3vs45","finalPrice":"styles-module__finalPrice___CyJb5"};